import React from 'react';
import css from './style.module.css';

export default function CheckBox(props) {
  const { id, text, checked, changeCheckBoxValue, disabled = false } = props;

  return (
    <div>
      <label className={css.container}>
        {text}
        <input
          id={id}
          key={id}
          type='checkbox'
          checked={checked}
          onChange={(e) => {
            changeCheckBoxValue(e.target.checked);
          }}
          disabled={disabled}
        />
        <span className={css.checkmark}></span>
      </label>
    </div>
  );
}
